import React, { useEffect } from "react";
import {scrollToTop} from "../../utils";
import S5 from '../Home/components/S5'

const Agreement = () => {

  useEffect(() => {
    scrollToTop()
  }, []);

  return (
    <S5 />
  )
}

export default Agreement;
